// @ts-expect-error ts(2307) can not find module
import Keycloak, { KeycloakInitOptions } from 'keycloak-js'
import { clientConfigurationProvider as getConfigValue } from '@ocean/configs'
import { LoggerUtils } from '@ocean/utils'
import { CustomerInformation } from 'core/system/types'
import ssoRoutes from 'modules/Sso/routing/routes'

export const isSsoEnabledForCustomer = (customerInformation?: CustomerInformation) => {
  return customerInformation?.ssoSettings?.enableSso
}

export const getKeycloakInstance = (
  realm: string,
  ssoKeyCloakServerUrl: string,
  ssoClientId: string
): any => {
  if (!ssoKeyCloakServerUrl || !ssoClientId) {
    LoggerUtils.log('Sso is not properly configured.')
    return null
  }
  const keycloakInstance = new Keycloak({
    url: ssoUrlFixer(`${ssoKeyCloakServerUrl}/`),
    realm,
    clientId: ssoClientId,
  })
  return keycloakInstance
}

export const createDefaultInitOptions = (encodedCustomerNameParam: string): KeycloakInitOptions => {
  return {
    onLoad: 'login-required',
    checkLoginIframe: false,
    silentCheckSsoFallback: true,
    silentCheckSsoRedirectUri: ssoUrlFixer(getSsoBaseAddress() + '/silent-check-sso.html'),
    redirectUri: ssoUrlFixer(
      `${getSsoBaseAddress()}${ssoRoutes.confirm}?ecn=${encodeURIComponent(
        encodedCustomerNameParam
      )}`
    ),
    enableLogging: process.env.NODE_ENV === 'development',
  }
}

export const getLogoutUrl = (authRoute: string, encodedCustomerNameParam: string) => {
  return ssoUrlFixer(
    `${getSsoBaseAddress()}${authRoute}?ecn=${encodeURIComponent(encodedCustomerNameParam)}&ssol=1`
  )
}

const getSsoBaseAddress = () => {
  const baseName = getConfigValue('baseName')
  return ssoUrlFixer(`${window.location.origin}/${baseName}`)
}

const ssoUrlFixer = (input: string) => {
  return input.replace(/([^:]\/)\/+/g, '$1')
}
